import { H1, H2, H3 } from 'UIComponents/elements/headings';
import styled, { css, mediaQuery, theme } from 'academy-common-lib/utils/Styling';
import { getProxyUrl } from 'academy-common-lib/utils/url';
import PublicPageBreadcrumbs from './PublicPageBreadcrumbs';
import I18n from 'I18n';
import EmbeddedSignup from '../../embeddedSignup/components/EmbeddedSignup';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MainDetailsSection = styled.section.withConfig({
  displayName: "PublicLandingPagePrimaryDetails__MainDetailsSection",
  componentId: "zzz75q-0"
})(["position:relative;min-height:450px;color:", ";padding-bottom:0px;padding-top:32px;margin-bottom:64px;"], theme.colors.OLAF);
const DetailsGrid = styled.div.withConfig({
  displayName: "PublicLandingPagePrimaryDetails__DetailsGrid",
  componentId: "zzz75q-1"
})(["display:grid;grid-template-columns:repeat(auto-fill,minmax(350px,1fr));grid-gap:48px;", ""], mediaQuery('mobile', css(["grid-template-columns:1fr;"])));
const SignupBox = styled.div.withConfig({
  displayName: "PublicLandingPagePrimaryDetails__SignupBox",
  componentId: "zzz75q-2"
})(["background-color:", ";position:absolute;min-height:800px;width:100%;box-shadow:0 0 13px rgba(0,0,0,0.5);", ""], theme.colors.OLAF, mediaQuery('mobile', css(["position:relative;"])));
const GradientBackground = styled(({
  className
}) => /*#__PURE__*/_jsx("div", {
  className: className,
  children: /*#__PURE__*/_jsx("svg", {
    className: "gradient-edge",
    preserveAspectRatio: "xMinYMin meet",
    viewBox: "0 0 500 50",
    children: /*#__PURE__*/_jsx("path", {
      d: "M0,50 L0,4 C95,-23 285,115 500,2 L500,50 L0,50 Z",
      style: {
        stroke: 'none',
        fill: 'rgb(255, 255, 255)'
      }
    })
  })
})).withConfig({
  displayName: "PublicLandingPagePrimaryDetails__GradientBackground",
  componentId: "zzz75q-3"
})(["position:absolute;z-index:-1;top:0;left:calc((100vw - 100%) / 2 * -1);height:calc(100% + 126px);width:100vw;", " &::before{content:'';display:block;background:", ";width:100%;height:100%;}.gradient-edge{position:absolute;bottom:-1px;left:0;width:100%;}"], mediaQuery('mobile', css(["height:calc(100% + 56px);"])), props => props.style === 'blue' ? 'linear-gradient(45deg, #7075db, #0fbfbf)' : 'linear-gradient(45deg,#0fbfbf,#4fb06d)');
const Headline = styled(H2).withConfig({
  displayName: "PublicLandingPagePrimaryDetails__Headline",
  componentId: "zzz75q-4"
})(["font-weight:500;"]);
const Description = styled.p.withConfig({
  displayName: "PublicLandingPagePrimaryDetails__Description",
  componentId: "zzz75q-5"
})(["a{color:", ";text-decoration:underline;&:hover{color:", ";}}"], theme.colors.OLAF, theme.colors.CALYPSO_LIGHT);
const CONTENT_TYPE_MESSAGE = {
  CERTIFICATION: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.contentLandingPage.primaryDetails.contentType.certification"
  }),
  TRACK: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.contentLandingPage.primaryDetails.contentType.course"
  }),
  LESSON: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.contentLandingPage.primaryDetails.contentType.lesson"
  })
};
const PublicLandingPagePrimaryDetails = /*#__PURE__*/forwardRef(({
  contentType,
  headline,
  name,
  description,
  parentName,
  parentPath,
  id,
  pagePath
}, ref) => {
  return /*#__PURE__*/_jsxs(MainDetailsSection, {
    children: [/*#__PURE__*/_jsx(GradientBackground, {
      style: contentType === 'LESSON' ? 'green' : 'blue'
    }), /*#__PURE__*/_jsx(PublicPageBreadcrumbs, {
      entries: [{
        name: I18n.text('academyPublic.contentLandingPage.primaryDetails.breadcrumbs.home'),
        href: getProxyUrl()
      }, {
        name: I18n.text('academyPublic.contentLandingPage.primaryDetails.breadcrumbs.library'),
        href: getProxyUrl('courses')
      }, ...(parentName && parentPath ? [{
        name: parentName,
        href: getProxyUrl(`courses/${parentPath}`)
      }] : []), ...(name ? [{
        name
      }] : [])]
    }), /*#__PURE__*/_jsxs(DetailsGrid, {
      children: [/*#__PURE__*/_jsxs("div", {
        children: [headline && /*#__PURE__*/_jsxs(Headline, {
          "data-test-id": "public-course-headline",
          children: [headline, ":"]
        }), name && /*#__PURE__*/_jsx(H1, {
          "data-test-id": "public-course-name",
          children: name
        }), /*#__PURE__*/_jsx(H3, {
          children: CONTENT_TYPE_MESSAGE[contentType]
        }), description && /*#__PURE__*/_jsx(Description, {
          dangerouslySetInnerHTML: {
            __html: description
          },
          "data-test-id": "public-course-description"
        })]
      }), /*#__PURE__*/_jsx("div", {
        style: {
          position: 'relative'
        },
        children: /*#__PURE__*/_jsx(SignupBox, {
          ref: ref,
          children: /*#__PURE__*/_jsx(EmbeddedSignup, {
            id: id,
            pagePath: pagePath,
            type: contentType
          })
        })
      })]
    })]
  });
});
export default PublicLandingPagePrimaryDetails;